import React from "react";
import styles from "./Error404.module.css";
import Button from "../../component/Button";
import { useNavigate } from "react-router-dom";
import ErrorImage from "../../assets/images/Error.png";

const Error404 = () => {
  const navigate = useNavigate();

  const onButtonClick = () => {
    if (true) {
      navigate("/");
    }
  };
  return (
    <>
      <div className='container'>
        <div className={styles.mainWrapper}>
          <div className={styles.ErrorHeading}>
            <p>OOPS !!!</p>
          </div>
          <div>
            <p className={styles.ErrorText}>
              The page you are looking for is not found.
            </p>
          </div>
          <img
            src={ErrorImage}
            className={styles.thankYouImage}
            alt='raised hand'
          />
        </div>
        {/* <div className={styles.bottomButtonWrapper}>
          <Button text='Go to Home' onClick={onButtonClick} disabled={false} />
        </div> */}
      </div>
    </>
  );
};

export default Error404;
